import React ,{useEffect,useState}from 'react'
import bgi from '../image/pricecard1.jpg'
import bgi1 from '../image/pricecard2.jpg'
import { Outlet, NavLink, useLocation } from "react-router-dom";
import manuments from '../image/manuments.jpeg'
import suchwita from '../image/suchwita.webp'
import jiminsproduction from '../image/jiminsproduction.webp'
import permission from '../image/permission.webp'
import yettocome from '../image/yettocome.png'
import todayshow from '../image/todayshow.jpg'
import runningman from '../image/runningman.jpg'
import thetonight from '../image/thetonight.png'
import jinnyskitchen from '../image/jinnyskitchen.jpg'
import thefirsttake from '../image/thefirsttake.jpg'
import npop from '../image/npop.jpg'
import youth from '../image/youth.jpg'

const VarietyShows = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden">
      <div class="py-3 flex items-center text-lg font-bold  text-blue-800 before:flex-[1_1_0%] before:border-t before:border-purple-800 before:me-6 after:flex-[1_1_0%] after:border-t after:border-purple-800 after:ms-6 dark:text-white dark:before:border-gray-600 dark:after:border-gray-600">Variety Shows</div>
   {/* <!-- Card Blog document row1 --> */}
   {/* documentry heading */}
   <div className='flex justify-center '>
   <span class="bg-blue-300 inline-flex items-center justify-center h-8 w-8 text-xs font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  D
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] text-sm font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  O
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.875rem] w-[2.875rem] text-sm font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  C
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.375rem] w-[3.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  U
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.715rem] w-[3.715rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  M
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[4.875rem] w-[4.875rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  E
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.275rem] w-[3.275rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  N
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.175rem] w-[3.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  T
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.950rem] w-[2.950rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  A
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.750rem] w-[2.750rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  R
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-8 w-8 font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  Y
</span>
</div>
   {/* documentry heading ends */}
<div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
  {/* <!-- Grid --> */}
  <div class="grid lg:grid-cols-2 gap-6">
    {/* <!-- Card --> */}
 <NavLink to="/varietydetails">   <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={manuments} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
              Documentry
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Monuments: Beyond the Star
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary Series
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>December 20, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>8
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}

    {/* <!-- Card --> */}
   <NavLink to="/varietydetails1"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={jiminsproduction} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Documentary
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Jimin's Production Diary
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span> October 23, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>TBD
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}
  </div>
  {/* <!-- End Grid --> */}
  <hr class="border-blue-500 mt-8"></hr>
</div>
{/* <!-- End Card Blog document row1 --> */}



   {/* <!-- Card Blog document row2 --> */}
<div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-0 mx-auto">
  {/* <!-- Grid --> */}
  <div class="grid lg:grid-cols-2 gap-6">
    {/* <!-- Card --> */}
   <NavLink to="/varietydetails2"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={suchwita} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Documentry
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Suchwita
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentry
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>December 5, 2022
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>8
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}

    {/* <!-- Card --> */}
  <NavLink to="/varietydetails3">  <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={permission} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Documentary
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Permission to Dance on Stage in the U.S.
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 27, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Runtime: </span>8 hrs 31 mins
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card document row2 --> */}
  </div>
  {/* <!-- End Grid --> */}
  <hr class="border-blue-500"></hr>






   {/* <!-- Card concert concert --> */}
   {/* concert heading */}
   <div className='flex justify-center p-5'>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.175rem] w-[2.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  C
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  O
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  N
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[4.375rem] w-[4.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  C
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  E
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  R
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.175rem] w-[2.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  T
</span>
</div>
   {/* concert heading ends*/}
   <div className='px-4 py-10 sm:px-6 lg:px-1 lg:py-5 mx-auto flex justify-center'>
   <NavLink to="/varietydetails4"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={yettocome} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Concert Film
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Yet to Come
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Concert Film
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 9, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Runtime: </span>TBD8 hrs 31 mins
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card concert --> */}
</div>
<hr class="border-blue-500"></hr>




   {/* variety shows heading */}
   <div className='flex justify-center p-5'>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.175rem] w-[2.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  V
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  A
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  R
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[4.375rem] w-[4.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  I
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  E
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  T
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.175rem] w-[2.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  Y
</span>
</div>
<div className='flex justify-center'>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  S
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  H
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[4.375rem] w-[4.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  O
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  W
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  S
</span>
</div>
   {/* variety shows ends*/}
   <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
  {/* <!-- Grid --> */}
  <div class="grid lg:grid-cols-2 gap-6">
    {/* <!-- Card --> */}
   <NavLink to="/varietydetails5"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={runningman} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Running Man
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 20, 2015
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>5
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}

    {/* <!-- Card --> */}
   <NavLink to="/varietydetails6"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={todayshow} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          TODAY Show
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span> February 21, 2020
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>4
          </p>
          </div>
        </div>
      </div>
    </a></NavLink>
    {/* <!-- End Card --> */}
  </div>
  {/* <!-- End Grid --> */}
  <hr class="border-blue-500 mt-8"></hr>
</div>
{/* <!-- End Card Blog document row1 --> */}


  {/* variety shows row2 ends*/}
  <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
  {/* <!-- Grid --> */}
  <div class="grid lg:grid-cols-2 gap-6">
    {/* <!-- Card --> */}
   <NavLink to="/varietydetails7"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={thetonight} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          The Tonight Show Starring Jimmy Fallon
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 25, 2018
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>14
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}

    {/* <!-- Card --> */}
    <NavLink to="/varietydetails8"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={jinnyskitchen} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Visiting God of Communication: Jinny's Kitchen
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span> October 12, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>TBD
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}
  </div>
  {/* <!-- End Grid --> */}
  <hr class="border-blue-500 mt-8"></hr>
</div>
{/* <!-- End Card Blog variety shows row2 --> */}




 {/* variety shows row3 ends*/}
 <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
  {/* <!-- Grid --> */}
  <div class="grid lg:grid-cols-2 gap-6">
    {/* <!-- Card --> */}
   <NavLink to="/varietydetails9"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={thefirsttake} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          The First Take
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 18, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>1
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}

    {/* <!-- Card --> */}
   <NavLink to="/varietydetails10"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={npop} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          NPOP
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  September 9, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>1
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card --> */}
  </div>
  {/* <!-- End Grid --> */}
  <hr class="border-blue-500 mt-8"></hr>
</div>
{/* <!-- End Card Blog variety shows row3 --> */}


   {/* <!-- Card concert concert --> */}
   {/* concert heading */}
   <div className='flex justify-center p-5'>
<span class=" bg-blue-300 inline-flex items-center justify-center h-[2.175rem] w-[2.175rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  K-
</span>
<span class="lg:ml-2 bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  D
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  R
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[4.375rem] w-[4.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  A
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[3.215rem] w-[3.215rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  M
</span>
<span class="bg-blue-300 inline-flex items-center justify-center h-[2.375rem] w-[2.375rem] font-bold rounded-full leading-none border border-gray-200 text-gray-800 shadow-sm dark:bg-slate-900 dark:border-gray-700 dark:text-white">
  A
</span>
</div>
   {/* concert heading ends*/}
   <div className='px-4 py-10 sm:px-6 lg:px-1 lg:py-5 mx-auto flex justify-center'>
   <NavLink to="/varietydetails11"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={youth} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            K-drama
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Youth
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>K-drama
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episodes: </span>TBA
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    {/* <!-- End Card concert --> */}
</div>
<hr class="border-blue-500"></hr>
</div>
{/* <!-- End Card Blog --> */}
    </div>
  )
}

export default VarietyShows
